<template>
  <div class="admin-welcome">
    <header-title title="Bienvenido al Panel de Administración"></header-title>

    <v-container fluid>
      <v-row dense>
        <v-col cols="12" lg="3" md="6" sm="6" xs="12">
          <v-card v-if="hasRoleOwner" class="mx-auto" max-width="344" outlined>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  <v-icon> mdi-view-dashboard </v-icon>
                  Dashboard
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-card-actions>
              <router-link to="/admin/dashboard/principal">
                <v-btn outlined>
                  Acceder
                </v-btn>
              </router-link>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col
          v-if="hasRoleOwner || hasRoleManager || hasRoleWaiter"
          cols="12"
          lg="3"
          md="6"
          sm="6"
          xs="12"
        >
          <v-card class="mx-auto" max-width="344" outlined>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  <v-icon> mdi-receipt </v-icon>
                  Crear Pedido
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-card-actions>
              <router-link to="/admin/orders/create-order">
                <v-btn outlined>
                  Acceder
                </v-btn>
              </router-link>
            </v-card-actions>
          </v-card>
        </v-col>
        <template v-if="hasRoleOwner || hasRoleManager || hasRoleWaiter">
          <v-col
            v-for="groupOrder in groupOrders"
            :key="`groupOrder_${groupOrder.id}`"
            cols="12"
            lg="3"
            md="6"
            sm="6"
            xs="12"
          >
            <v-card class="mx-auto" max-width="344" outlined>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">
                    <v-icon> mdi-glass-cocktail </v-icon>
                    {{ groupOrder.name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-card-actions>
                <router-link :to="`/admin/orders-group/${groupOrder.id}`">
                  <v-btn outlined>
                    Acceder
                  </v-btn>
                </router-link>
              </v-card-actions>
            </v-card>
          </v-col>
        </template>

        <v-col
          v-if="hasRoleOwner || hasRoleManager || hasRoleWaiter"
          cols="12"
          lg="3"
          md="6"
          sm="6"
          xs="12"
        >
          <v-card class="mx-auto" max-width="344" outlined>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  <v-icon> mdi-paper-roll-outline </v-icon>
                  Cuentas Abiertas
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-card-actions>
              <router-link to="/admin/orders-open/list">
                <v-btn outlined>
                  Acceder
                </v-btn>
              </router-link>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col
          v-if="hasRoleOwner || hasRoleManager"
          cols="12"
          lg="3"
          md="6"
          sm="6"
          xs="12"
        >
          <v-card class="mx-auto" max-width="344" outlined>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  <v-icon> mdi-receipt</v-icon>
                  Cierres de caja (Z)
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-card-actions>
              <router-link to="/admin/orders/cierres-de-caja-z">
                <v-btn outlined>
                  Acceder
                </v-btn>
              </router-link>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col v-if="hasRoleOwner" cols="12" lg="3" md="6" sm="6" xs="12">
          <v-card class="mx-auto" max-width="344" outlined>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  <v-icon> mdi-share-variant </v-icon>
                  Ver Carta Pública
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-card-actions>
              <router-link target="_blank " to="/carta">
                <v-btn outlined>
                  Acceder
                </v-btn>
              </router-link>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <br /><br />
    <v-card class="mx-auto" max-width="344" max-height="60" outlined>
      <v-list-item-title>
        <a target="_blank" href="https://www.aiwannapay.com/">
          <img
            src="@/assets/images/aiwannapaylogo.png"
            class="admin-logo-aiwanna"
            alt="aiwanna pay"
          />
        </a>
      </v-list-item-title>
    </v-card>
  </div>
</template>

<script>
import HeaderTitle from "@/components/admin/common/HeaderTitle";
import { groupOrdersCollection } from "@/collections/groupOrders";

export default {
  name: "Welcome",
  components: { HeaderTitle },
  data() {
    return {
      groupOrders: []
    };
  },
  firestore() {
    return {
      groupOrders: groupOrdersCollection.where("active", "==", true)
    };
  },
  computed: {
    hasRoleOwner() {
      return this.$store.getters.hasRoleOwner;
    },
    hasRoleManager() {
      return this.$store.getters.hasRoleManager;
    },
    hasRoleWaiter() {
      return this.$store.getters.hasRoleWaiter;
    }
  }
};
</script>
